/*!
 *
 *  Appacus - Agile Product Development Studio
 *  Copyright 2015 Google Inc. All rights reserved.
 *
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *    https://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License
 *
 */
/* eslint-env browser */
(function() {
  'use strict';

  // Check to make sure service workers are supported in the current browser,
  // and that the current page is accessed from a secure origin. Using a
  // service worker from an insecure origin will trigger JS console errors. See
  // http://www.chromium.org/Home/chromium-security/prefer-secure-origins-for-powerful-new-features
  var isLocalhost = Boolean(window.location.hostname === 'localhost' ||
      // [::1] is the IPv6 localhost address.
      window.location.hostname === '[::1]' ||
      // 127.0.0.1/8 is considered localhost for IPv4.
      window.location.hostname.match(
        /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
      )
    );

  if ('serviceWorker' in navigator &&
      (window.location.protocol === 'https:' || isLocalhost)) {
    navigator.serviceWorker.register('service-worker.js')
    .then(function(registration) {
      // updatefound is fired if service-worker.js changes.
      registration.onupdatefound = function() {
        // updatefound is also fired the very first time the SW is installed,
        // and there's no need to prompt for a reload at that point.
        // So check here to see if the page is already controlled,
        // i.e. whether there's an existing service worker.
        if (navigator.serviceWorker.controller) {
          // The updatefound event implies that registration.installing is set:
          // https://slightlyoff.github.io/ServiceWorker/spec/service_worker/index.html#service-worker-container-updatefound-event
          var installingWorker = registration.installing;

          installingWorker.onstatechange = function() {
            switch (installingWorker.state) {
              case 'installed':
                // At this point, the old content will have been purged and the
                // fresh content will have been added to the cache.
                // It's the perfect time to display a "New content is
                // available; please refresh." message in the page's interface.
                break;

              case 'redundant':
                throw new Error('The installing ' +
                                'service worker became redundant.');

              default:
                // Ignore
            }
          };
        }
      };
    }).catch(function(e) {
      console.error('Error during service worker registration:', e);
    });
  }

  // sticky stuff
  $(".layer").pin({ activeClass: 'sticky-on', minWidth: 768 });

  // email links
  jQuery('.mailer').on('click', function sendMail(e) {
    document.location = 'mailto:info@appac.us?subject=Getting in touch from appac.us';
    e.preventDefault();
    e.stopPropagation();
  })

  // Expand menu  if visible
  var menu = jQuery('.menu-open');
  // setTimeout(function () {
  //   window.scrollY < 180 && menu.prop('checked', true); //document.getElementById('menu-open').checked = true
  // }, 820);

  // hide header if not visible
  var headerEl = jQuery('#Header');
  // function hideHeaderContentOutsideViewport() {
  //   if (window.scrollY <= $(window).height()) {
  //     headerEl.show();
  //   } else {
  //     headerEl.hide();
  //   }
  // }

  /**
   * Krivulja 2
   */
  // var krivulja2 = document.getElementById('krivulja2');
  // var krivulja2Offset = jQuery('#krivulja2').offset().top;
  // function animateCurve2() {
  //   var scrollposstart = krivulja2Offset + window.innerHeight;
  //   var scroller = scrollposstart - window.scrollY; 
  //   var value = 130 - 45 * scroller / window.innerHeight;

  //   // console.log (scroller, window.innerHeight, value, scrollposstart, window.scrollY, krivulja2Offset);

  //   if (value < -20 ) value = -20;
  //   if (value > 84 ) value = 84;

  //   krivulja2.setAttribute('d','M0 100 C 20 ' + value + ' 50 ' + value + ' 100 100 Z')
  // }

  /**
   * Krivulja 3
   */
  // var krivulja3 = document.getElementById('krivulja3');
  // var krivulja3Offset = jQuery('#krivulja3').offset().top;
  // var scrollposstart = krivulja3Offset - window.innerHeight;
  // var factor = krivulja3Offset / 100;
  // function animateCurve3() {
  //   var scroller = window.scrollY - scrollposstart; 
  //   var value = 100 - (scroller) * .3 * (window.innerWidth/window.innerHeight);
  //   if (value < 20 ) value = 20;
  //   if (value > 100 ) value = 100;

  //   krivulja3.setAttribute('d','M0 0 C50 ' + value + ' 50 ' + value + ' 100 0 Z')
  // }

  var overScroll = false;
  window.addEventListener('scroll', function () {
    if (window.scrollY >= (window.innerHeight * .7) && !overScroll) {
      // menu.prop('checked', false);
      headerEl.addClass('scrolled');
      overScroll = true;
    } else if (window.scrollY < (window.innerHeight * .7)) {
      // menu.prop('checked', true);
      headerEl.removeClass('scrolled');
      overScroll = false;
    }

    // animateCurve2();
    // animateCurve3();
    // hideHeaderContentOutsideViewport(); 
    // stickToTop();
  });

  // resize footer
  function resizeFooter() {
    jQuery('#Footer').height(jQuery('#footerContent').height())
  }

  setTimeout(resizeFooter, 1000);

  function onWindowResize(){
    resizeFooter();
  }

  window.addEventListener( 'resize', onWindowResize, false );


  /**
   * Update hamburger menu over the coffee mug
   */
  var image = { width: 1200, height: 799 };
  var target = { x: 840, y: 325 };

  var pointer = $('#menuwrapper .menu');

  $(document).ready(updatePointer);
  $(window).resize(updatePointer);

  function updatePointer() {
      var windowWidth = $(window).width();
      var windowHeight = $(window).height();

      // Get largest dimension increase
      var xScale = windowWidth / image.width;
      var yScale = windowHeight / image.height;
      var scale;
      var yOffset = 0;
      var xOffset = 0;

      if (xScale > yScale) {
          // The image fits perfectly in x axis, stretched in y
          scale = xScale;
          yOffset = (windowHeight - (image.height * scale)) / 2;
      } else {
          // The image fits perfectly in y axis, stretched in x
          scale = yScale;
          xOffset = (windowWidth - (image.width * scale)) / 2;
      }

      pointer.css('top', (target.y) * scale + yOffset);
      pointer.css('left', (target.x) * scale + xOffset);
  }

  var htmlBody = $('html, body');
  $(document).on('click', 'a.local', function(event){
      event.preventDefault();
      var offset = $( $.attr(this, 'href') ).offset();

      htmlBody.animate({
          scrollTop: offset ? offset.top : 0
      }, 800);
  });

})();

